import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { Subscription } from 'rxjs';
import { UserState } from '../../store/reducers/user.reducers';
import { Store } from '@ngrx/store';
import { UserActions } from '../../store/actions/user.actions';
import { V2AuthService } from 'src/app/services/v2auth.service';

@Component({
    selector: 'app-redirection',
    templateUrl: './redirection.component.html',
    styleUrls: ['./redirection.component.scss']
})
export class RedirectionComponent implements OnInit {
    public currentUser: any;
    public token: any;
    public isLoading: boolean = true;
    private subscriptions: Subscription = new Subscription();
  
    constructor(
      private userService: UserService,
      private auth: V2AuthService,
      private router: Router,
      private route: ActivatedRoute,
      private store: Store<{ user: UserState }>
    ) {}
  
    ngOnInit(): void {
      this.subscriptions.add(
        this.route.queryParams.subscribe({
          next: (params) => {
            const token = params['token'];
            if (token) {
              this.redeemToken(token);
            } else {
              this.doRedirection();
            }
          },
          error: (err) => this.handleError(err, 'Invalid login link.')
        })
      );
    }

   private redeemToken(token: string): void {
    this.subscriptions.add(
      this.auth.redeemLoginToken(token).subscribe({
        next: (response) => {
          if (response?.token) {
            this.token = response.token;
            this.auth.saveToken(this.token);
            this.fetchCurrentUser(); 
          } else {
            this.handleError(null, 'Invalid token response.');
          }
        },
        error: (err) => this.handleError(err, 'Error while redeeming login token.')
      })
    );
    }

  
    public doRedirection(): void {
      this.auth.isLoggedIn().subscribe(isLogged => {
          if (isLogged) {
              this.fetchCurrentUser();
          } else {
              this.handleUnauthenticated();
          }
      }, (error) => {
          this.handleUnauthenticated();
      });
    }

    private fetchCurrentUser(): void {
      this.subscriptions.add(
        this.userService.newLogin().subscribe({
          next: (user) => {
            if (user?.userId) {
              this.currentUser = user;
              this.store.dispatch(UserActions.registerCurrentUser({ user }));
              this.userService.getUserById(Number(user.userId)).subscribe((res) => {
                this.store.dispatch(UserActions.registerUserInfo({ user: res }));
                this.navigateFromLogin(); 
              });
            } else {
              this.handleError(null, 'Invalid user data received.');
            }
          },
          error: (err) => this.handleError(err, 'Error while fetching current user.')
        })
      );
    }

    private handleUnauthenticated(): void {
    this.isLoading = false;
    this.router.navigate(['/login']);
    }
  
    private navigateFromLogin(): void {
      if (!this.currentUser || !this.currentUser.redirectTo) {
          this.handleError(null, 'Error while redirection. Cannot obtain user data.');
          return;
      }

      const redirectPath = this.currentUser.redirectTo;
      console.log(`Navigating to: ${redirectPath}`);

      localStorage.setItem("redirectTo", redirectPath); 

      this.router.navigate([redirectPath]).then(() => {
      }).catch(err => {
          this.router.navigate(["/login"]); 
      });
    }


    private handleError(error: any, message: string): void {
      sessionStorage.clear();
      localStorage.clear();
      localStorage.setItem('error', message);
      localStorage.setItem('error--v', JSON.stringify(error));
      this.auth.logout();
    }
  
    ngOnDestroy(): void {
      this.subscriptions.unsubscribe();
    }
}
